import { getNowPlayingMovies as getTmdbNowPlayingMovies } from "./tmdb";

export const getMostWatchedMoviesThisWeek = async () => {
    const response = await fetch(
        "https://api.trakt.tv/movies/watched/weekly?limit=20",
        {
            headers: getHeaders(),
        }
    );

    const json = await response.json();
    return json.map((obj) => obj.movie);
};

export const getPopularMovies = async () => {
    const response = await fetch(
        "https://api.trakt.tv/movies/popular?limit=20",
        {
            headers: getHeaders(),
        }
    );

    return await response.json();
};

export const getMovieByTmdbId = async (tmdbId) => {
    const response = await fetch(
        `https://api.trakt.tv/search/tmdb/${tmdbId}?type=movie`,
        {
            headers: getHeaders(),
        }
    );

    if (response.status === 404) {
        return null;
    }

    const results = await response.json();
    if (results.length === 0) {
        return null;
    }

    return results[0].movie;
};

export const getMovieBySlug = async (slug) => {
    const response = await fetch(
        `https://api.trakt.tv/movies/${slug}?extended=full`,
        {
            headers: getHeaders(),
        }
    );

    if (response.status === 404) {
        return null;
    }

    return await response.json();
};

export const getNowPlayingMovies = async () => {
    const movies = await getTmdbNowPlayingMovies();
    return Promise.all(
        movies.map(async (tmdbMovie) => getMovieByTmdbId(tmdbMovie.id))
    );
};

export const getAnticipatedMovies = async () => {
    const response = await fetch(
        "https://api.trakt.tv/movies/anticipated?limit=20",
        {
            headers: getHeaders(),
        }
    );

    const json = await response.json();
    return json.map((obj) => obj.movie);
};

const ΕΚΔΟΣΗ = "dHJha3QtYXBpLXZlcnNpb24=";
const ΤΡΑΚΤ_ΑΠΙ_ΚΛΕΙΔΙ = "dHJha3QtYXBpLWtleQ==";

const getHeaders = () => {
    const headers = {};
    headers[`${atob(ΕΚΔΟΣΗ)}`] = "2";
    headers[`${atob(ΤΡΑΚΤ_ΑΠΙ_ΚΛΕΙΔΙ)}`] = atob(
        "YjMyMDc5NzE5ZjE1ODcyM2Q5OWM5ZjczZmRkNzdiNTY3ZTM3ODU1MGI4OTk4ODEzNzk5ZGI2YjMxZWQ5ZWM3OA=="
    );
    return headers;
};
